/**
 * Formats a duration in seconds into a human-readable string.
 * Examples: 30 -> "30s", 90 -> "1m 30s", 3600 -> "1h", 3660 -> "1h 1m"
 */
export function formatDuration(seconds: number): string {
  if (seconds >= 3600) {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    return mins > 0 ? `${hrs}h ${mins}m` : `${hrs}h`;
  }
  if (seconds >= 60) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return secs > 0 ? `${mins}m ${secs}s` : `${mins}m`;
  }
  return `${seconds}s`;
}
